import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ModalText = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${36 * Screen.widthRatio}px;
  text-align: center;
`;

export default ModalText;
